export default __webpack_public_path__ + "static/media/path-icon.2133998d.svg";